import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import toast from 'react-hot-toast'
import { PhoneStatus } from 'interfaces/physical-phone'

interface UpdatePhysicalPhoneStatusParams {
  phoneId: string
  status: PhoneStatus
}

const updatePhysicalPhoneStatus = async ({
  phoneId,
  status,
}: UpdatePhysicalPhoneStatusParams) => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/physical_phones/${phoneId}`,
    {
      method: API_METHODS.PUT,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify({ status }),
    }
  )
  response = handleErrors(response)
  return response.json()
}

const useUpdatePhysicalPhoneStatus = () => {
  const queryClient = useQueryClient()

  return useMutation(updatePhysicalPhoneStatus, {
    onError: (error: Error) => {
      console.error('Failed to update Physical Phone status:', error)
      toast.error(`Failed to update Physical Phone status: ${error.message}`)
    },
    onSuccess: (data, variables) => {
      toast.success('Physical Phone status updated successfully')

      // Invalidate related queries
      queryClient.invalidateQueries([
        'physical-phone-detail',
        variables.phoneId,
      ])
      queryClient.invalidateQueries(['physical-phones-by-ansible'])
      queryClient.invalidateQueries(['received-physical-phones'])
      queryClient.invalidateQueries(['ansible-detail'])
    },
  })
}

export default useUpdatePhysicalPhoneStatus
